import React, {useState} from "react";
import {Link} from "gatsby";

import {locales, getCurrentLocale} from "../../utils/getCurrentLocale";

import langSelectorStyles from './LanguageSelector.module.scss';


const LanguageSelector = (props) => {
    const currentLocale = getCurrentLocale(props.location.pathname);

    let source = props.location.pathname;
    source = source.endsWith("/") ? source.slice(0, props.location.pathname.length - 1) : source;
    const currentPath = source.split('/').slice(source.split('/').length - 2).join("/");

    const [shouldSelectorOpen, setShouldSelectorOpen] = useState(false);

    const openSelector = (event) => setShouldSelectorOpen(true);
    const closeSelector = (event) => setShouldSelectorOpen(false);

    return (
        <div
            className = {langSelectorStyles.langSelectorContainer}
            role = "listbox"
            tabIndex = "0"
            onMouseEnter = {openSelector}
            onMouseLeave = {closeSelector}
        >
            {shouldSelectorOpen
                ? <div className = {langSelectorStyles.langSelectorActiveWrapper}>{currentLocale} <span>v</span></div>
                : undefined
            }
            <div className = {langSelectorStyles.langCurrent}>{currentLocale} <span>v</span></div>
            {shouldSelectorOpen
                ? <ul className = {langSelectorStyles.langSelectorItemContainer}>
                    {Object.keys(locales).map((lang, i) =>
                        <Link
                            id = {`lang-item-${lang}`}
                            className = {langSelectorStyles.langSelectorItem}
                            key = {i}
                            to = {`/${lang}/${currentPath}/`}
                        >
                            {lang}
                        </Link>
                    )}
                </ul>
                : undefined
            }
        </div>
    )
};


export default LanguageSelector;
